import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCouponsBasedOnDomainAction } from "../../../Store/CouponBaseOnDomain/actions";
import CouponCard from "../../Ui/CouponCardVertical";
import {
  getCouponByIdAction,
  getRecommendBannerAction,
} from "../../../Store/Coupons/actions";
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import { BASE_URL } from "../../../Config/axiosInstance";

const zoomInAnimation = keyframes`${zoomIn}`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomInAnimation};
`;

function Deals({ history, match }) {
  const dispatch = useDispatch();

  const { couponbaseondomainList } = useSelector(
    (store) => store.CouponBasedOnDomain
  );

  const { couponByID, getRecommendBanner } = useSelector(
    (state) => state.Coupon
  );

  const handleClick = (redirectUrl) => {
    const anchor = document.createElement("a");
    anchor.href = redirectUrl;
    anchor.target = "_blank";
    document.body.appendChild(anchor);
    anchor.click();
  };

  useEffect(() => {
    if (couponbaseondomainList.length === 0) {
      dispatch(getCouponsBasedOnDomainAction());
    }
  }, [couponbaseondomainList, dispatch]);

  useEffect(() => {
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id === undefined
    ) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id !== undefined
    ) {
      window.open(
        `/couponsredirect/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    dispatch(getRecommendBannerAction({ dimension: "300 * 250" }));
  }, [dispatch]);

  return (
    <div style={{ background: "#f0f0f0" }} className="pt-0">
      <Container style={{ padding: "1rem 0" }}>
        <Row>
          {couponbaseondomainList.map((coupon, index) =>
            index === 3 && getRecommendBanner[0] ? (
              <Col
                md={6}
                sm={6}
                xs={12}
                lg={3}
                className="mb-1 pb-3"
                key={index}
              >
                <ZoomInDiv
                  className="d-flex align-items-center flex-column justify-content-center couponCard h-100"
                  onClick={() =>
                    handleClick(getRecommendBanner[0]?.redirect_url)
                  }
                >
                  <img
                    style={{
                      objectFit: "contain",
                      width: "-webkit-fill-available",
                    }}
                    loading="lazy"
                    src={`${BASE_URL}/${getRecommendBanner[0].image_upload}`}
                    alt=""
                  />
                </ZoomInDiv>
              </Col>
            ) : index === 11 && getRecommendBanner[1] ? (
              <Col
                md={6}
                sm={6}
                xs={12}
                lg={3}
                className="mb-1 pb-3"
                key={index}
              >
                <ZoomInDiv
                  className="d-flex align-items-center flex-column justify-content-center couponCard h-100"
                  onClick={() =>
                    handleClick(getRecommendBanner[1]?.redirect_url)
                  }
                >
                  <img
                    style={{
                      objectFit: "contain",
                      width: "-webkit-fill-available",
                    }}
                    loading="lazy"
                    src={`${BASE_URL}/${getRecommendBanner[1].image_upload}`}
                    alt=""
                  />
                </ZoomInDiv>
              </Col>
            ) : index === 17 && getRecommendBanner[2] ? (
              <Col
                md={6}
                sm={6}
                xs={12}
                lg={3}
                className="mb-1 pb-3"
                key={index}
                style={{background:"red"}}
              >
                <ZoomInDiv
                  className="d-flex align-items-center flex-column justify-content-center couponCard h-100"
                  onClick={() =>
                    handleClick(getRecommendBanner[2]?.redirect_url)
                  }
                >
                  <img
                    style={{
                      objectFit: "contain",
                      width: "-webkit-fill-available",
                    }}
                    loading="lazy"
                    src={`${BASE_URL}/${getRecommendBanner[2].image_upload}`}
                    alt=""
                  />
                </ZoomInDiv>
              </Col>
            ) : (
              <Col
                md={6}
                sm={6}
                xs={12}
                lg={3}
                className="mb-1 pb-3"
                key={index}
              >
                <CouponCard coupon={coupon} history={history} />
              </Col>
            )
          )}
        </Row>
      </Container>
    </div>
  );
}

export default Deals;
